import { Body, Button, colors, Dialog, Form, Spacer } from '@spritz-finance/ui'
import React from 'react'
import { SubmitHandler } from 'react-hook-form'
import styled, { css } from 'styled-components'
import { Column } from '../../../../components/Layout/Column'
import { Row } from '../../../../components/Layout/Row'
import { useRenameBillMutation } from '../../../../graphql/generated/graphql'
import { InstitutionImage } from '../InstitutionImage'
import { Bill } from './Bills'

const RenameAccountContainer = styled.div<{ $removed?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.2s ease-out;
    ${({ $removed }) =>
        $removed &&
        css`
            opacity: 0;
        `};
`

interface RenameFormData {
    name: string
}

const TopWrapper = styled.div`
    width: 100%;
    display: flex;
`

interface RenameBillDialogProps {
    bill: Bill | null
    onClose: () => void
}

export const RenameBillDialog: React.VFC<RenameBillDialogProps> = ({ onClose, bill }) => {
    const [renameBill, { loading }] = useRenameBillMutation({
        optimisticResponse: (vars) => {
            return {
                renameBill: {
                    ...bill!,
                    name: vars.name,
                },
            }
        },
    })

    const handleCloseDialog = () => {
        if (loading) return
        onClose()
    }

    const onSubmit: SubmitHandler<RenameFormData> = async (data) => {
        renameBill({
            variables: {
                name: data.name,
                accountId: bill!.accountId,
            },
        })
        onClose()
    }

    return (
        <Dialog open={!!bill} onClose={handleCloseDialog}>
            <Dialog.Content>
                <Dialog.Title>Rename bill</Dialog.Title>
                <RenameAccountContainer $removed={false}>
                    <Spacer height={32} />
                    <TopWrapper>
                        <Row>
                            <InstitutionImage institution={bill?.institution} />
                        </Row>
                        <Spacer width={16} />
                        <Column>
                            <Body.SmBold color={colors.charcoal} size={14}>
                                {bill?.institution?.name}
                            </Body.SmBold>
                            {bill?.originalName && (
                                <>
                                    <Spacer height={4} />
                                    <Body.SmBold size={14}>{bill?.originalName}</Body.SmBold>
                                </>
                            )}
                        </Column>
                    </TopWrapper>

                    <Spacer height={16} />
                    <Form<RenameFormData> onSubmit={onSubmit} initialValues={{ name: bill?.name }}>
                        <Form.Input
                            autoComplete="off"
                            name="name"
                            placeholder="Account name"
                            validation={{ required: true }}
                        />
                        <Spacer height={32} />
                        <Row align="center">
                            <Button.CTA type="submit" disabled={loading} style={{ width: '110px' }}>
                                Rename
                            </Button.CTA>
                        </Row>
                    </Form>
                </RenameAccountContainer>
            </Dialog.Content>
        </Dialog>
    )
}
